
export default {
  name: 'Distrcts',
  methods: {
    $_getDistrictName (place) {
      return place.address.match(/^([^\s]+)/)[0]
    },

    $_getDistrictNames (places) {
      let districts = []

      places.forEach(place => {
        districts.push(this.$_getDistrictName(place))
      }) // forEach

      return districts
        .sort()
        .reduce((a, b) => {
          if (a.slice(-1)[0] !== b) a.push(b) // slice(-1)[0] 을 통해 마지막 아이템을 가져온다.
          return a
        }, [])
    },

    /**
     * 장소 목록
     *
     * @returns Map 빠른 검색이 되도록 map 을 return
     */
    $_getPlaces () {
      return new Promise((resolve, reject) => {
        this.$fs
          .collection('places')
          .where('group', '==', this.$store.state.session.group)
          .orderBy('name')
          .get()
          .then((querySnapshot) => {
            const places = new Map()

            querySnapshot.forEach(document => {
              let item = document.data()
              item.id = document.id
              item.districtName = this.$_getDistrictName(item)
              item.chargers = new Map()

              places.set(item.id, item)
            }) // forEach

            resolve(places)
          }) // then
          .catch(error => {
            reject(error)
          })
      })
    },

    $_getDistricts (places) {
      return new Promise((resolve, reject) => {
        let districtNames = this.$_getDistrictNames(places)
        const districts = new Map()

        districtNames.forEach(name => {
          districts.set(name, {'name': name,
            'places': new Map(),
            'chargers': new Map()})
        })

        // console.log(this.districts)
        resolve(districts)
      })
    },

    $_getChargers () {
      return new Promise((resolve, reject) => {
        this.$fs
          .collection('chargers')
          .where('group', '==', this.$store.state.session.group)
          .get()
          .then((querySnapshot) => {
            const chargers = new Map()

            querySnapshot.forEach(document => {
              let item = document.data()
              item.id = document.id

              chargers.set(item.id, item)
            }) // forEach

            resolve(chargers)
          }) // then
          .catch(error => {
            reject(error)
          })
      })
    },

    $_getPlugs () {
      return new Promise((resolve, reject) => {
        this.$fs
          .collection('plugs')
          .where('group', '==', this.$store.state.session.group)
          .get()
          .then((querySnapshot) => {
            const plugs = new Map()

            querySnapshot.forEach(document => {
              let item = document.data()
              item.id = document.id

              plugs.set(item.id, item)
            }) // forEach

            resolve(plugs)
          }) // then
          .catch(error => {
            reject(error)
          })
      })
    },

    $_getCheckers () {
      return new Promise((resolve, reject) => {
        this.$fs
          .collection('checkers')
          .where('group', '==', this.$store.state.session.group)
          .orderBy('name')
          .get()
          .then((querySnapshot) => {
            const checkers = new Map()

            querySnapshot.forEach(document => {
              let item = document.data()
              item.id = document.id

              checkers.set(item.id, item)
            }) // forEach

            resolve(checkers)
          }) // then
          .catch(error => {
            reject(error)
          })
      })
    },

    /**
     * 지역:충전소 = 1:N
     *
     * @param {Map} districts
     * @param {Map} places
     */
    $_setPlaces (districts, places) {
      places.forEach(place => {
        const district = districts.get(place.districtName)

        if (district) {
          district.places.set(place.id, place) // 지역에 충전소

          // 순환 참조는 메모리 GC 에서 비워지지 않아 사용하지 않음
          // place.district = district // 충전소에 지역
        }
      })
    },

    /**
     * 충전소:충전기 = 1:N
     *
     * @param {Map} districts
     * @param {Map} chargers
     */
    $_setChargers (districts, chargers) {
      districts.forEach(district => {
        district.places.forEach(place => {
          if (place.chargerRefs) {
            place.chargerRefs.forEach(chargerRef => {
              const charger = chargers.get(chargerRef.id)

              if (charger) {
                charger.place = place
                district.chargers.set(charger.id, charger)
                // 순환 참조는 메모리 GC 에서 비워지지 않아 사용하지 않음
                // place.chargers.set(charger.id, charger)
                // charger.place = place
                // place.district.chargers.set(charger.id, charger)
                // charger.district = place.district
                charger.nickname = `${place.name} - ${charger.managementNumber}`
              }
            })
          }
        })
      })
    },

    /**
     * place:checker = N:1
     *
     * @param {Map} districts
     * @param {Map} checkers
     */
    $_setCheckers (districts, checkers) {
      districts.forEach(district => {
        district.places.forEach(place => {
          if (place.checkerRef) {
            const checker = checkers.get(place.checkerRef.id)

            if (checker) {
              place.checker = checker
            }
          }
        })
      })
    },

    /**
     * 충전기와 플러그는 1:1
     *
     * @param {Map} districts
     * @param {Map} plugs
     */
    $_setPlugs (districts, plugs) {
      districts.forEach(district => {
        district.chargers.forEach(charger => {
          if (charger.plugRef) {
            const plug = plugs.get(charger.plugRef.id)

            if (plug) {
              charger.plug = plug

              // 순환 참조는 메모리 GC 에서 비워지지 않아 사용하지 않음
              // plug.charger = charger
            }
          }
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/Districts.js